import { FormattedMessage } from "react-intl";

const KnowledgeBase = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraServiceManagementPricingPageTeam24.features.knowledgeBase.content.body"
                    defaultMessage="Create, read, update, and delete articles. Recommend relevant articles to customers to enable self service and deflect requests."
                />
            </p>
        </div>
    );
};

export default KnowledgeBase;
